import { Box, makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) => ({

}));

export const PayoffCardRow = observer(({ children, className = undefined }) => {
  const classes = useStyles();
  return (
    <Box style={{ margin: 'auto', borderBottom: 'solid 0.5px', width: '100%' }} display='flex' justifyContent='left' className={className}>
      {children}
    </Box>
  )
});